import React from 'react';

import Box from '../Box/Box';
import name from './name';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TTextFieldFormControl = {
  isFocused?: boolean;
  isErrored?: boolean;
  isDirty?: boolean;
  isTouched?: boolean;
  isEmpty?: boolean;
  isMultiline?: boolean;
  children?: React.ReactNode;
};

const TextFieldFormControl = ({
  isErrored,
  isFocused,
  isDirty,
  isTouched,
  isEmpty,
  isMultiline,
  ...rest
}: TTextFieldFormControl) => {
  const conditionalProps = filterConditionalKeyValues({
    states: [
      isFocused && 'focused',
      isErrored && 'errored',
      isDirty && 'dirty',
      isTouched && 'touched',
      !isEmpty && 'filled',
    ],
    modifiers: isMultiline && 'multiline',
  });

  return <Box {...rest} {...conditionalProps} parent={name} name="formControl" as="div" />;
};

export default TextFieldFormControl;
